import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { Box } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { Table } from "../../components/Table";
import { listCampaigns } from "../../services/campaigns";
import Stack from "@mui/material/Stack";
import { useStyles } from "./styles";
import { DatePicker } from "../../components/DatePicker";
import { format, subMonths } from "date-fns";
import Button from "@mui/material/Button";
import { Cancel, CheckCircle, Search } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
import { green, red } from "@mui/material/colors";
import SmsIcon from "../../assets/campaign/sms.png";
import WhatsAppIcon from "../../assets/campaign/whatsapp.png";
import EmailIcon from "../../assets/campaign/email.png";
import InstagramIcon from "../../assets/campaign/instagram.png";
import FacebookIcon from "../../assets/campaign/facebook.png";
import { Campaign as TypeCampaign } from "../../types/campaign";
import { Campaign as TypeCampaignn } from "../../types/results";
import { CampaignDetails } from "./Details";
import { DialogProfile } from "../../components/DialogProfile";
//import { textAlign } from "@mui/system";

export function Campaign() {
  const styles = useStyles();
  const [dialogProfile, setDialogProfile] = useState<boolean>(false);

  const [campaign, setCampaign] = useState<TypeCampaign | null>(null);
  const [campaignn, setCampaignn] = useState<TypeCampaignn>();

  const [dialogDetailCampaign, setDialogDetailCampaign] =
    useState<boolean>(false);
  const [name, setName] = useState<string>();
  const [startDate, setStartDate] = useState<Date>(subMonths(new Date(), 1));
  const [endDate, setEndDate] = useState<Date>(new Date());

  const iconsCampaigns = useMemo(() => {
    return {
      email: EmailIcon,
      sms: SmsIcon,
      sms_v2: SmsIcon,
      whatsapp: WhatsAppIcon,
      instagram: InstagramIcon,
      instagram_carousel: InstagramIcon,
      facebook: FacebookIcon,
      whatsapp_group: WhatsAppIcon,
    };
  }, []);

  const handleDialogProfile = useCallback((row: TypeCampaignn) => {
    setCampaignn(row);
    setDialogProfile((prev) => !prev);
  }, []);

  const campaigns = useQuery("campaigns", async () => {
    const params = {
      grupoCampanha: "CONCLUIDO",
      filtroDataInicio: format(startDate, "yyyy-MM-dd"),
      filtroDataFim: format(endDate, "yyyy-MM-dd"),
      nome_campanha: name,
    };
    const response = await listCampaigns(params);

    return [...response];
  });

  const invalidateCampaigns = useCallback(() => {
    campaigns.refetch();
  }, [campaigns]);

  const handleDialogDetailsCampaign = useCallback(
    (row: TypeCampaign | null) => {
      setCampaign(row);

      setDialogDetailCampaign((prev) => !prev);
    },
    []
  );

  const RenderName = (item: TypeCampaign) => {
    return (
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ justifyContent: "space-between" }}
      >
        <img
          className={styles.imgIcon}
          src={iconsCampaigns[String(item.tipo_campanha).toLowerCase()]}
          alt="sms-icon"
        />
        <Typography className={styles.typographyNameCampaing}>
          {item.nome_campanha}
        </Typography>
      </Stack>
    );
  };

  const RenderStatus = (item: TypeCampaign) => {
    switch (item.processado) {
      case 0:
      case 1:
        return (
          <Tooltip title="Campanha em andamento" placement="top">
            <CircularProgress size={22} thickness={4} />
          </Tooltip>
        );
      case 2:
        return (
          <Tooltip title="Campanha concluída" placement="top">
            <CheckCircle style={{ fontSize: 25, color: green[600] }} />
          </Tooltip>
        );
      case 3:
        return (
          <Tooltip title="Campanha com erro" placement="top">
            <Cancel style={{ fontSize: 25, color: red[600] }} />
          </Tooltip>
        );
    }
  };
  const renderId = (row: any) => {
    let nivel = 1;
    let listIDs = [row.origem_campanha];
    var idOriginCampaing: number = row.origem_campanha;

    function lacoIds(id: Number) {
      if (id !== null) {
        nivel++;
        let campanha: any = campaigns.data.find((a) => a.ID_CAMPANHA === id);
        id = campanha.origem_campanha;
        if (id !== null) {
          listIDs.unshift(campanha.origem_campanha);
        }
        return lacoIds(id);
      }
      return id;
    }
    lacoIds(idOriginCampaing);
    if (nivel > 1) {
      return (
        <Box className={styles.boxID}>
          {listIDs.map((id) => {
            return (
              <Box sx={{ display: "flex" }}>
                <Typography className={styles.typographyIDs}>{id}</Typography>
                <ArrowForwardIosRoundedIcon
                  color="action"
                  sx={{ fontSize: "14px", margin: "5px" }}
                />
              </Box>
            );
          })}
          <Typography
            className={styles.typographyID}
            sx={{ fontWeight: "500" }}
          >
            {row.ID_CAMPANHA}
          </Typography>
        </Box>
      );
    }
    return (
      <Typography className={styles.typographyIDPrincipal}>
        {row.ID_CAMPANHA}
      </Typography>
    );
  };

  const renderClient = (row: any) => {
    if (row.origem_campanha !== null) {
      if (row.prospeccao_tipo === 1) {
        return (
          <Typography
            className={styles.typographyComprou}
            sx={{ fontSize: "12px", fontWeight: "500" }}
            id={"verClientes"}
            onClick={() => {
              handleDialogProfile(row);
            }}
          >
            Comprou
          </Typography>
        );
      } else {
        if (row.prospeccao_tipo === 2) {
          return (
            <Typography
              className={styles.typographyNaoComprou}
              sx={{ fontWeight: "500", fontSize: "12px" }}
              id={"verClientes"}
              onClick={() => {
                handleDialogProfile(row);
              }}
            >
              Não comprou
            </Typography>
          );
        }
      }
    }
    return <Typography></Typography>;
  };

  return (
    <>
      <div className={styles.root}>
        <Typography variant="h4">Disparo em canais digitais</Typography>
      </div>
      <div className={styles.rootActions}>
        <Stack direction="row" spacing={1}>
          <TextField
            fullWidth
            size="small"
            label="Campanha"
            onChange={({ target: { value } }) => setName(value)}
            value={name}
          />
          <DatePicker
            fullWidth
            size="small"
            label="Data de início"
            onChange={(date: Date) => setStartDate(date)}
            value={startDate}
          />
          <DatePicker
            fullWidth
            size="small"
            label="Data de término"
            onChange={(date: Date) => setEndDate(date)}
            value={endDate}
          />
          <Button
            onClick={invalidateCampaigns}
            fullWidth
            startIcon={<Search />}
            color="primary"
          >
            Buscar
          </Button>
        </Stack>
      </div>
      <Paper variant="outlined" elevation={0} className={styles.paper}>
        <Table
          pageSize={10}
          toolbar={false}
          data={
            campaigns?.data?.map((item) => ({
              id: item.ID_CAMPANHA,
              ...item,
            })) as []
          }
          isLoading={campaigns.isFetching}
          onRowClick={(evt: any, selectedRow: any) => {
            if (evt.target.id !== "verClientes") {
              handleDialogDetailsCampaign(selectedRow);
            }
          }}
          headerStyle={{
            backgroundColor: "#F4F3FB",
            color: "#1D1D1D",
            zIndex: 0,
            padding: "25px 0 25px 25px",
          }}
          columns={[
            {
              title: "ID",
              field: "ID_CAMPANHA",
              cellStyle: {
                color: "#4F4F4F",
                padding: "0px",
                paddingLeft: "7px",
              },
              render: (row) => (
                <Box className={styles.boxOneID}>{renderId(row)}</Box>
              ),
            },
            {
              title: "Nome",
              field: "nome_campanha",
              align: "center",
              render: RenderName,
              cellStyle: { color: "#4F4F4F" },
            },
            {
              title: "Status",
              field: "processado",
              align: "center",
              render: RenderStatus,
            },
            {
              title: "Ações",
              align: "center",
              render: (row) => (
                <Box className={styles.boxActions}>
                  <Button
                    id={"verClientes"}
                    onClick={() => {
                      handleDialogProfile(row);
                    }}
                    sx={{ color: "#4F4F4F" }}
                  >
                    Ver clientes
                  </Button>
                  {renderClient(row)}
                </Box>
              ),
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            pageSize: 10,
            selectionProps: () => ({
              color: "primary",
            }),
          }}
          style={{ border: "none" }}
          //headerStyle={{ backgroundColor: "transparent" }}
          parentChildData={(row, rows) =>
            rows.find((a) => a.ID_CAMPANHA === row.origem_campanha)
          }
        />
      </Paper>
      <CampaignDetails
        data={campaign}
        open={dialogDetailCampaign}
        onClose={() => {
          handleDialogDetailsCampaign(null);
        }}
      />
      {dialogProfile && (
        <DialogProfile
          data={campaignn}
          open={dialogProfile}
          onClose={() => {
            handleDialogProfile(null);
          }}
          onSuccesss={() => {
            handleDialogProfile(null);
            invalidateCampaigns();
          }}
          isCampaign={true}
        />
      )}
    </>
  );
}
